import React from 'react';
import AppBar from '@mui/material/AppBar';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ButtonBase, Toolbar, Typography, Box, Button } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Logo from './Logo';

function CustomAppBar() {
  const location = useLocation();
  const navigate = useNavigate();
  // console.log(location.pathname);

  return (
    <div>
      <AppBar
        position='static'
      >
        {/* login button */}
        <Toolbar>
          {/* Clicking logo redirects user to Home */}
          
          <Box sx={{marginLeft: '20px', flexGrow: 1}}>
            <ButtonBase onClick={() => {navigate('/home')}}>
              <Logo variant="h6" color="white" />
            </ButtonBase>
          </Box>
          {/* If path is Landing Page, then display Login and Sign In */}
          {location.pathname === '/' ? 
          (<Box>
            <Button onClick={() => {navigate('/login')}} variant='outlined' sx={{color: 'white', borderColor: 'white'}}>
              Login
            </Button>
            <Button onClick={() => {navigate('/sign-up')}} sx={{backgroundColor: 'white', color: "primary", marginLeft: '5px', 
            '&:active': {
              backgroundColor: 'rgba(255, 255, 255, 0.6)', // More transparent white on click
              boxShadow: 'none', // Remove box shadow on click
            }}}>
              Sign up
            </Button>
          </Box>
          )
            
            /* Otherwise, display My Account */
            : 
            <Box sx={{display: 'flex', alignItems: 'center'}}>
              <ButtonBase sx={{marginLeft: '20px'}} onClick={() => {navigate('/faq')}}><HelpOutlineIcon /></ButtonBase>
              <ButtonBase sx={{marginLeft: '20px'}} onClick={() => {navigate('/my-account')}}><PersonIcon/></ButtonBase>
            </Box>
        }

        </Toolbar>
      </AppBar>
    </div>
  )
}

export default CustomAppBar